var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("ConfirmationDialog2", { ref: "confirmationDialog" }),
      _vm._v(" "),
      _vm._t("default", null, { submit: _vm.ingest, loading: _vm.loading }),
      _vm._v(" "),
      _c("ExecutionResultsDialog", {
        ref: "executionResultsDialog",
        attrs: { title: "Ingestion" },
        scopedSlots: _vm._u([
          {
            key: "next",
            fn: function ({ ReingestionId }) {
              return [
                _c(
                  "PrimaryBtn",
                  {
                    attrs: {
                      icon: "event_note",
                      to: {
                        name: "allimports",
                        query: { search: ReingestionId },
                      },
                    },
                  },
                  [_vm._v("View ingestion summary")]
                ),
                _vm._v(" "),
                _c(
                  "PrimaryBtn",
                  {
                    attrs: {
                      icon: "pending_actions",
                      to: {
                        name: "reviewingestionresults",
                        params: { executionId: ReingestionId },
                      },
                    },
                  },
                  [_vm._v("Review ingestion")]
                ),
              ]
            },
          },
          {
            key: "actions",
            fn: function ({ ReingestionId }) {
              return [
                ReingestionId
                  ? [
                      _c(
                        "PrimaryBtn",
                        {
                          attrs: {
                            icon: "event_note",
                            to: {
                              name: "allimports",
                              query: { search: ReingestionId },
                            },
                          },
                        },
                        [_vm._v("View ingestion summary")]
                      ),
                      _vm._v(" "),
                      _c(
                        "PrimaryBtn",
                        {
                          attrs: {
                            icon: "pending_actions",
                            to: {
                              name: "reviewingestionresults",
                              params: { executionId: ReingestionId },
                            },
                          },
                        },
                        [_vm._v("Review ingestion")]
                      ),
                    ]
                  : _vm._e(),
              ]
            },
          },
        ]),
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }